import React from 'react'

const PlayIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      {/* Play triangle */}
      <path 
        d="M8 5v14l11-7z"
        fill="currentColor"
      />
    </svg>
  )
}

export default PlayIcon
